import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import { WatchIcon } from './WatchIcon';
import { t } from '../../../services/translation/translation';

type Props = {
  trip: TripOutput;
};
export const DriverPreviousDropOff = ({ trip }: Props) => {
  return (
    <div className="flex justify-between items-center gap-x-2">
      <div className="flex-col flex w-full">
        <strong> {t('share-route.trip-detail.driver-previous-drop')}</strong>
        <span>{t('share-route.trip-detail.driver-arrival-time-with-drop')}</span>
      </div>
      <WatchIcon eta={trip.driver?.etaBeforeInDaPlace ? trip.driver?.etaBeforeInDaPlace : '--'} />
    </div>
  );
};
